import { type Actions, ActionType } from './repartition-categories.actions';
import { initialState, repartitionCategoryAdapter, type State } from './repartition-categories.state';

export function repartitionCategoryReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return initialState;
        }
        case ActionType.FETCH_REPARTITION_CATEGORY: {
            return { ...state, isPending: true };
        }
        case ActionType.FETCH_REPARTITION_CATEGORY_SUCCEEDED: {
            return repartitionCategoryAdapter.setAll(action.payload.repartitionCategories, { ...state, isLoaded: true, isPending: false });
        }
        case ActionType.FETCH_REPARTITION_CATEGORY_FAILED: {
            return { ...state, isLoaded: false, isPending: false };
        }
        case ActionType.CREATE_REPARTITION_CATEGORY: {
            return repartitionCategoryAdapter.addOne(action.payload.repartitionCategory, state);
        }
        case ActionType.DELETE_REPARTITION_CATEGORY: {
            return repartitionCategoryAdapter.removeOne(action.payload.repartitionCategoryId, state);
        }
        default:
            return state;
    }
}
